document.querySelectorAll(".accordian-p").forEach((item) => {
    item.classList.add("accordian")
});

document.querySelectorAll(".accordian-p .accordian-item").forEach((row, i) => {
    row.classList.remove("selected");

    row.children[0].addEventListener("click", () => {
        row.classList.toggle("selected");
    })
});

document.querySelector("#accordian-expand")?.addEventListener("click", (e) => {
    e.target.closest(".macro-course-content").querySelectorAll(".accordian-item").forEach((item) => {
        item.classList.add("selected");
    });
});

document.querySelector("#accordian-collapse")?.addEventListener("click", (e) => {
    e.target.closest(".macro-course-content").querySelectorAll(".accordian-item").forEach((item) => {
        item.classList.remove("selected");
    });
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            if ($(".panel").hasClass("city-links-courses")) {
                panel.style.maxHeight = 600 + "px";
            }
        }
    });
}

window.addEventListener('load', function() {
    var courseAccordians = document.querySelectorAll('#course-content .accordian-item');
    courseAccordians[0]?.classList.add('selected')
    
    var faqAccordions = document.querySelectorAll('#faq .accordian-item');
    faqAccordions[0]?.classList.add('selected');
});
